module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_5.4a78dbd9.png";